import DBOperationsComb from "src/utils/dbOperationsComb";
import Exception from "src/utils/exception";
import Constants from "@/utils/constants";

async function getJobPlanInfoList(config) {
  try {
    return await DBOperationsComb.fetchData(
      {
        tableName: Constants.enums.TABLES_NAME_ENUM.JOB_PLAN_INFO_TABLE,
        ...config
      },
      true
    );
  } catch (error) {
    Exception.catchException(error);
    return {
      error: error,
      data: []
    };
  }
}

export default {
  getJobPlanInfoList
};
